import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import Container = Phaser.GameObjects.Container;
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export class FeedbackPanel extends Phaser.GameObjects.Container {

    private parent: Container | undefined;

    constructor(scene: Scene, text: string, parent: Container | undefined, isPositive: boolean, dy?:number) {
        super(scene);

        this.scene = scene;
        this.x = 300 * CU.S;
        this.y = 80 * CU.S;
        this.setDepth(15000);
        this.parent = parent;

        const back = SpriteUtils.addImage(this.scene, 0, 0 + (dy || 0), Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_TITLE_LIGHT);
        SpriteUtils.setDispSize(back, 550 * CU.S, 220 * CU.S);

        let messageText = TextUtils.addTextAdvanced(scene, text, 0, 0 + (dy || 0),
            isPositive ? '#9cff8f' : '#ff6a6a', 30, 'normal', 450, 'center', 2, Fonts.BENGALY_NORMAL);
        messageText.setStroke('#000000', 1);

        this.add([back, messageText]);
    }

    public show() {
        if (this.parent) {
            this.parent.add(this);
        } else {
            this.scene.add.existing(this);
        }

        let self = this;
        this.scene!.tweens.chain({
            targets: self,
            tweens: [{
            },
                {
                    y: self.y - 20 * CU.S,
                    duration: 2500,
                },
                {
                    x: 300 * CU.S,
                    y: self.y - 100 * CU.S,
                    alpha: 0,
                    duration: 3000,
                    onComplete() {
                        self.destroy();
                    }
                }]
        });
    }

}
